import { Filter, isWhitespaceString } from '@ami/react/core';

export class AmiTaskFilter extends Filter {
  constructor(filter) {
    super(filter);
    if (filter) {
      this.search = isWhitespaceString(filter.search) ? null : filter.search;
      this.typeId = filter.typeId;
      this.status = filter.status;
      this.assigneeId = filter.assigneeId;
      this.assigneeName = filter.assigneeName;
      this.createdId = filter.createdId;
      this.createdName = filter.createdName;
      this.startDate = filter.startDate;
      this.endDate = filter.endDate;
      this.includeOrderLine = filter.includeOrderLine;
      this.isForRecentsWidget = filter.isForRecentsWidget;
      this.onlyAssignedToCurrentUser = filter.onlyAssignedToCurrentUser;
      this.onlyCreatedToCurrentUser = filter.onlyCreatedToCurrentUser;
      this.subscriberId = filter.subscriberId;
      this.subcsriberName = filter.subcsriberName;
      this.includeAssociation = filter.includeAssociation;
      this.preventPoSubmission = filter.preventPoSubmission;
      return this;
    }
    this.search = '';
    this.typeId = '';
    this.status = '';
    this.assigneeId = null;
    this.assigneeName = '';
    this.createdId = null;
    this.createdName = '';
    this.startDate = null;
    this.endDate = null;
    this.includeOrderLine = false;
    this.isForRecentsWidget = false;
    this.onlyAssignedToCurrentUser = false;
    this.onlyCreatedToCurrentUser = false;
    this.subscriberId = null;
    this.subcsriberName = '';
    this.includeAssociation = false;
    this.preventPoSubmission = false;
  }

  toPayload() {
    return {
      ...this,
      search: isWhitespaceString(this.search) ? null : this.search,
      startDate: this.mapDate(this.startDate),
      endDate: this.mapDate(this.endDate),
    };
  }
}
